import React from 'react';
import { Link } from 'react-router';
import { Row, Col, Button } from 'react-bootstrap';
import Icon from 'react-fa';
import MainPage from '../../components/MainPage.react';
import CrossChannelActions from '../../actions/CrossChannelActions';
import CrossChannelIndexStore from '../../stores/CrossChannelIndexStore';
import FilteringScenarioTable from './components/FilteringScenarioTable.react';
import ScenarioFilter from './components/ScenarioFilter.react';

function getFilter(filter) {
  return {
    filter,
  };
}

const padding = { paddingLeft: '10px' };

export default class CrossChannelIndex extends React.Component {
  constructor(props) {
    super(props);
    this.getState = this.getState.bind(this);
    this.state = this.getState();
    this._onChange = this._onChange.bind(this);
    this._onUpdateFilter = this._onUpdateFilter.bind(this);
    this.resetCrossChannelForm = this.resetCrossChannelForm.bind(this);
  }

  componentDidMount() {
    this.IndexStoreSubscription = CrossChannelIndexStore.addListener(this._onChange);
    this.scenarioSubscription = CrossChannelActions.pollForScenarios();
  }

  componentWillUnmount() {
    this.IndexStoreSubscription.remove();
    this.scenarioSubscription();
  }

  getState() {
    const organizationId = CrossChannelIndexStore.getOrganizationId();
    return {
      draftScenarios: CrossChannelIndexStore.getDraftScenarios(organizationId),
      runningScenarios: CrossChannelIndexStore.getRunningScenarios(organizationId),
      completedScenarios: CrossChannelIndexStore.getCompletedScenarios(organizationId),
      filter: (this.state || {}).filter,
      organizationId,
    };
  }

  _onChange() {
    this.setState(this.getState());
  }

  resetCrossChannelForm() {
    CrossChannelActions.reset(1);
    const { router } = this.context;
    router.push('/crosschannel/new/');
  }

  _onUpdateFilter(e) {
    this.setState(getFilter(e.target.value));
  }

  render() {
    return (
      <MainPage>
        <Row>
          <Col md={9}>
            <ScenarioFilter onUpdateFilter={this._onUpdateFilter} />
          </Col>
          <Col md={3}>
            <Link to='/crosschannel/new'>
              <Button
                block
                bsStyle='primary'
                onClick={this.resetCrossChannelForm}
              >
                New scenario
                <Icon name='plus-circle' size='lg' style={padding} />
              </Button>
            </Link>
          </Col>
        </Row>

        <FilteringScenarioTable
          title='Running'
          scenarios={this.state.runningScenarios}
          filter={this.state.filter}
        />
        <FilteringScenarioTable
          title='Draft'
          scenarios={this.state.draftScenarios}
          filter={this.state.filter}
        />
        <FilteringScenarioTable
          title='Completed'
          scenarios={this.state.completedScenarios}
          filter={this.state.filter}
        />
      </MainPage>
    );
  }
}
